import React, { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "./ui/tabs";
import { READY_NOTIFICATIONS } from "../data/content";

const categories = Object.keys(READY_NOTIFICATIONS);

export const ReadyNotifications = () => {
  const [copied, setCopied] = useState(null);

  const copy = (text, key) => {
    const done = () => {
      setCopied(key);
      toast.success("Notifica copiata!");
      setTimeout(() => setCopied(null), 1500);
    };
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(text).then(done).catch(done);
    } else {
      done();
    }
  };

  return (
    <section id="notifiche" className="py-20 sm:py-28" data-testid="ready-notifications-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-2xl">
          <span className="text-sm font-bold uppercase tracking-[0.2em] text-brand">50 notifiche pronte</span>
          <h1 className="mt-3 font-heading text-3xl sm:text-4xl font-bold tracking-tight text-brand-deep">
            Copia, adatta e invia
          </h1>
          <p className="mt-4 font-body text-base sm:text-lg text-ink leading-relaxed">
            Messaggi pronti all'uso per ogni occasione. Personalizza i campi tra parentesi
            (es. <span className="text-brand font-semibold">[Nome attività]</span>) e sei pronto a inviare.
          </p>
        </div>

        <Tabs defaultValue={categories[0]} className="mt-12">
          <TabsList className="flex flex-wrap h-auto gap-2 bg-transparent p-0 justify-start">
            {categories.map((cat) => (
              <TabsTrigger
                key={cat}
                value={cat}
                data-testid={`notif-tab-${cat}`}
                className="rounded-full border border-gray-200 bg-white px-4 py-2 font-body text-sm font-medium text-ink data-[state=active]:bg-brand data-[state=active]:text-white data-[state=active]:border-brand transition-colors"
              >
                {cat}
              </TabsTrigger>
            ))}
          </TabsList>

          {categories.map((cat) => (
            <TabsContent key={cat} value={cat} className="mt-8">
              <div className="grid sm:grid-cols-2 gap-4">
                {READY_NOTIFICATIONS[cat].map((text, i) => {
                  const key = `${cat}-${i}`;
                  return (
                    <div
                      key={key}
                      className="group flex items-start justify-between gap-3 rounded-2xl bg-white border border-gray-100 p-4 shadow-sm transition-all hover:border-brand/30 hover:shadow-md"
                      data-testid={`notif-card-${key}`}
                    >
                      <p className="font-body text-[15px] text-ink leading-relaxed">{text}</p>
                      <button
                        onClick={() => copy(text, key)}
                        data-testid={`notif-copy-${key}`}
                        aria-label="Copia notifica"
                        className="flex h-9 w-9 flex-none items-center justify-center rounded-xl bg-brand-light/30 text-brand transition-colors hover:bg-brand hover:text-white"
                      >
                        {copied === key ? <Check size={16} strokeWidth={3} /> : <Copy size={16} strokeWidth={2.5} />}
                      </button>
                    </div>
                  );
                })}
              </div>
            </TabsContent>
          ))}
        </Tabs>
      </div>
    </section>
  );
};
